import KeLi from '@/assets/images/Ke Li.jpg'
import ZaichunLiu from '@/assets/images/Zaichun Liu.jpg'
import MingyanChuai from '@/assets/images/Mingyan Chuai.jpg'
import YuanYuan from '@/assets/images/Yuan Yuan.jpg'
import JifeiSun from '@/assets/images/Jifei Sun.jpg'
import YanXu from '@/assets/images/Yan Xu.jpg'
import ZhengxinZhu from '@/assets/images/Zhengxin Zhu.jpg'
import TaoliJiang from '@/assets/images/Taoli Jiang.jpg'
import XinhuaZheng from '@/assets/images/Xinhua Zheng.jpg'
import MohsinAli from '@/assets/images/Mohsin Ali.jpg'
import TouqeerAhmad from '@/assets/images/Touqeer Ahmad.jpg'
import MuhammadSajid from '@/assets/images/Muhammad Sajid.jpg'
import MingmingWang from '@/assets/images/Mingming Wang.jpg'
import ShuangLiu from '@/assets/images/Shuang Liu.jpg'
import KaiZhang from '@/assets/images/Kai Zhang.jpg'
import YahanMeng from '@/assets/images/Yahan Meng.jpg'
import NaChen from '@/assets/images/Na Chen.jpg'
import ChunyueShen from '@/assets/images/Chunyue Shen.jpg'
import SunhyeongPark from '@/assets/images/Sunhyeong Park.jpg'
import JinghaoChen from '@/assets/images/Jinghao Chen.jpg'
import QiaPeng from '@/assets/images/Qia Peng.jpg'
import ZehuiXie from '@/assets/images/Zehui Xie.jpg'
import JingwenXu from '@/assets/images/Jingwen Xu.jpg'
import HaosongJiang from '@/assets/images/Haosong Jiang.jpg'
import ZihanLin from '@/assets/images/Zihan Lin.jpg'
import RuihaoLuo from '@/assets/images/Ruihao Luo.jpg'
import DongshengLiang from '@/assets/images/Dongsheng Liang.jpg'
import JingchenZhou from '@/assets/images/Jingchen Zhou.jpg'
import WeipingWang from '@/assets/images/Weiping Wang.jpg'
import YiminLi from '@/assets/images/Yimin Li.jpg'
import FangwangMing from '@/assets/images/Fangwang Ming.jpg'
import KaiZheng from  '@/assets/images/Kai Zheng.jpg'
import RuizeMa from  '@/assets/images/Ruize Ma.jpg'

let members = [
    {
        "name": "李科",
        "name_en": "Ke Li",
        "email": "kelee@ustc.edu.cn",
        "identity": "Postdoc",
        "year": "",
        "photo": KeLi
        ,
        "duration": ""
    }, {
        "name": "刘再春",
        "name_en": "Zaichun Liu",
        "email": "liuzaichun@ustc.edu.cn",
        "identity": "Postdoc",
        "year": "",
        "photo": ZaichunLiu
    }, {
        "name": "揣明艳",
        "name_en": "Mingyan Chuai",
        "email": "chuaimy20@ustc.edu.cn",
        "identity": "Postdoc",
        "year": "",
        "photo": MingyanChuai
        ,
        "duration": ""
    }, {
        "name": "袁园",
        "name_en": "Yuan Yuan",
        "email": "yuany93@ustc.edu.cn",
        "identity": "Postdoc",
        "year": "",
        "photo": YuanYuan
        ,
        "duration": ""
    }, {
        "name": "孙继飞",
        "name_en": "Jifei Sun",
        "email": "jifeisun@mail.ustc.edu.cn",
        "identity": "Postdoc",
        "year": "",
        "photo": JifeiSun
        ,
        "duration": ""
    }, {
        "name": "胥燕",
        "name_en": "Yan Xu",
        "email": "yanxu15@ustc.edu.cn",
        "identity": "Postdoc",
        "year": "",
        "photo": YanXu
        ,
        "duration": ""
    }, {
        "name": "朱正新",
        "name_en": "Zhengxin Zhu",
        "email": "zzxalf@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2019,
        "photo": ZhengxinZhu
        ,
        "duration": ""
    }, {
        "name": "蒋涛立",
        "name_en": "Taoli Jiang",
        "email": "jiangtl@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2020,
        "photo": TaoliJiang
        ,
        "duration": ""
    }, {
        "name": "郑新华",
        "name_en": "Xinhua Zheng",
        "email": "xhzheng@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2020,
        "photo": XinhuaZheng
        ,
        "duration": ""
    }, {
        "name": "穆赫辛 阿里",
        "name_en": "Mohsin Ali",
        "email": "mohsinali144@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2020,
        "photo": MohsinAli
        ,
        "duration": ""
    }, {
        "name": "",
        "name_en": "Touqeer Ahmad",
        "email": "touqeer@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2020,
        "photo": TouqeerAhmad
        ,
        "duration": ""
    }, {
        "name": "",
        "name_en": "Muhammad Sajid",
        "email": "sajid@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2020,
        "photo": MuhammadSajid
        ,
        "duration": ""
    }, {
        "name": "王明明",
        "name_en": "Mingming Wang",
        "email": "mmwang1@mail.ustc.edu.cn",
        "identity": "Ph.D. Student",
        "year": 2021,
        "photo": MingmingWang
        ,
        "duration": ""
    }, {
        "name": "刘双",
        "name_en": "Shuang Liu",
        "email": "519152106@qq.com",
        "identity": "Ph.D. Student",
        "year": 2021,
        "photo": ShuangLiu
        ,
        "duration": ""
    }, {
        "name": "张凯",
        "name_en": "Kai Zhang",
        "email": "aguaizk0216@163.com",
        "identity": "Ph.D. Student",
        "year": 2021,
        "photo": KaiZhang
        ,
        "duration": ""
    }, {
        "name": "孟亚寒",
        "name_en": "Yahan Meng",
        "email": "yahanmeng@mail.ustc.edu.cn",
        "identity": "M.S. Student",
        "year": 2020,
        "photo": YahanMeng
        ,
        "duration": ""
    }, {
        "name": "陈娜",
        "name_en": "Na Chen",
        "email": "chna@mail.ustc.edu.cn",
        "identity": "M.S. Student",
        "year": 2020,
        "photo": NaChen
        ,
        "duration": ""
    }, {
        "name": "沈淳悦",
        "name_en": "Chunyue Shen",
        "email": "shency@mail.ustc.edu.cn",
        "identity": "M.S. Student",
        "year": 2020,
        "photo": ChunyueShen
        ,
        "duration": ""
    }, {
        "name": "朴宣炯",
        "name_en": "Sunhyeong Park",
        "email": "sunh0410@mail.ustc.edu.cn",
        "identity": "M.S. Student",
        "year": 2020,
        "photo": SunhyeongPark
        ,
        "duration": ""
    }, {
        "name": "陈景豪",
        "name_en": "Jinghao Chen",
        "email": "m18075015569@163.com",
        "identity": "M.S. Student",
        "year": 2021,
        "photo": JinghaoChen
        ,
        "duration": ""
    }, {
        "name": "彭洽",
        "name_en": "Qia Peng",
        "email": "pengqia@mail.ustc.edu.cn",
        "identity": "M.S. Student",
        "year": 2021,
        "photo": QiaPeng
        ,
        "duration": ""
    }, {
        "name": "谢泽辉",
        "name_en": "Zehui Xie",
        "email": "1228617442@qq.com",
        "identity": "M.S. Student",
        "year": 2021,
        "photo": ZehuiXie,
        "duration": ""
    }, {
        "name": "许婧雯",
        "name_en": "Jingwen Xu",
        "email": "xjw050269@163.com",
        "identity": "M.S. Student",
        "year": 2021,
        "photo": JingwenXu,
        "duration": ""
    }, {
        "name": "江浩松",
        "name_en": "Haosong Jiang",
        "email": "chemy_jiang@mail.ustc.edu.cn",
        "identity": "Undergraduate",
        "year": 2018,
        "photo": HaosongJiang,
        "duration": ""
    }, {
        "name": "林子涵",
        "name_en": "Zihan Lin",
        "email": "linzihan322@mail.ustc.edu.cn",
        "identity": "Undergraduate",
        "year": 2018,
        "photo": ZihanLin,
        "duration": ""
    }, {
        "name": "骆睿昊",
        "name_en": "Ruihao Luo",
        "email": "nobeen@mail.ustc.edu.cn",
        "identity": "Undergraduate",
        "year": 2018,
        "photo": RuihaoLuo,
        "duration": ""
    }, {
        "name": "梁东升",
        "name_en": "Dongsheng Liang",
        "email": "liangdongsheng@mail.ustc.edu.cn",
        "identity": "Alumni",
        "year": 2017,
        "photo": DongshengLiang,
        "duration": "2019.9-2021.7"
    }, {
        "name": "周靖辰",
        "name_en": "Jingchen Zhou",
        "email": "zc424087508@mail.ustc.edu.cn",
        "identity": "Undergraduate",
        "year": 2018,
        "photo": JingchenZhou,
        "duration": ""
    },
    {
        "name": "马瑞泽",
        "name_en": "Ruize Ma",
        "email": "maruize@mail.ustc.edu.cn",
        "identity": "Undergraduate",
        "year": 2019,
        "photo": RuizeMa,
        "duration": ""
    },{
        "name": "王卫平",
        "name_en": "Weiping Wang",
        "email": "wwp2018@mail.ustc.edu.cn",
        "identity": "Visiting Scholar",
        "year": 2021,
        "photo": WeipingWang,
        "duration": ""
    },
    {
        "name": "明芳望",
        "name_en": "Fangwang Ming",
        "email": "fangwang.ming@kaust.edu.sa",
        "identity": "Alumni",
        "year": "",
        "photo": FangwangMing,
        "duration": "2019.10-2020.1"
    },
    {
        "name": "李一民",
        "name_en": "Yimin Li",
        "email": "libby_cn@mail.ustc.edu.cn",
        "identity": "Alumni",
        "year": 2018,
        "photo": YiminLi,
        "duration": "2019.12-2021.5"
    },
    {
        "name": "郑凯",
        "name_en": "Kai Zheng",
        "email": "zhengk@mail.ustc.edu.cn",
        "identity": "Alumni",
        "year": "",
        "photo": KaiZheng,
        "duration": "2021.6-2021.8"
    },

];

export default members;